export const COURSE_SOURCE_DUPLICATED = [
  'MDM',
  'EMMA',
  'ECOMATELAS',
  'KLAREO',
  'MORPHEABED',
  '2AB',
  'COOPTECHNO',
  'JDCOM',
]

export const COURSE_SOURCE_DUPLICATED_LIVRAISON_IMPOSSIBLE = ['LECLERC']

export const CONNECTOR_COURSE_DUPLICATED = ['SBO']

export const COURSE_SOURCE_ETAT_POINTAGE = ['MDM']
export const COURSE_SOURCE_EDIT_PACKAGE = ['MDM']
export const COURSE_SOURCE_CALENDAR = ['MDM', 'CONFORAMA']
export const COURSE_SOURCE_CALENDAR_DISABLED = ['CONFORAMA']
export const COURSE_SOURCE_BLOQUAGE_PROGRAMMATION = ['MDM']
export const COURSE_SOURCE_BLOQUAGE_CHECK_SEND_MAIL_PROGRAMMATION = [
  'MDM',
  'CONFORAMA',
]

export const COURSE_SOURCE_DATE_ENLEVEMENT = ['LECLERC']
